import { type AccountTypeEnum } from "~/graphql/supergraphTypes";

export type ProfileRelationshipTypeForProfileMap = {
  id: number;
  parentProfileId: number;
  relationshipType: string;
  percentOwnership: number | null;
  title?: string | null;
};

export type ProfileTypeForProfileMap = {
  id: number;
  accountType: AccountTypeEnum | null;
  parentRelationships: ProfileRelationshipTypeForProfileMap[];
};

export type InvestingProfileTypeForProfileMap = {
  id: number;
  accountType?: AccountTypeEnum | null;
};

export type ComplianceCaseTypeForProfileMap = {
  investingProfile?: InvestingProfileTypeForProfileMap | null;
  profiles?: (ProfileTypeForProfileMap | null)[] | null;
};

export const getProfilesMapById = (
  complianceCase?: ComplianceCaseTypeForProfileMap | null,
): Map<number, ProfileTypeForProfileMap> => {
  const profileMap = new Map<number, ProfileTypeForProfileMap>();
  if (!complianceCase) return profileMap;

  if (complianceCase?.investingProfile?.id) {
    profileMap.set(complianceCase.investingProfile.id, {
      id: complianceCase.investingProfile.id,
      accountType: complianceCase.investingProfile.accountType ?? null,
      parentRelationships: [],
    });
  }

  if (complianceCase?.profiles) {
    for (const profile of complianceCase.profiles) {
      if (profile?.id) {
        profileMap.set(profile.id, {
          id: profile.id,
          accountType: profile.accountType,
          parentRelationships: profile.parentRelationships,
        });
      }
    }
  }

  return profileMap;
};
